import React from 'react';
import { useToasts, useUIActions } from '../store';
import { CheckCircleIcon, ExclamationCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';

const ToastContainer: React.FC = () => {
  const toasts = useToasts();
  const { removeToast } = useUIActions();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed inset-0 z-50 pointer-events-none">
      <div className="flex flex-col items-center justify-start min-h-screen pt-20 space-y-3">
        {toasts.map((toast) => (
          <div
            key={toast.id}
            className={`pointer-events-auto max-w-2xl w-full rounded-xl shadow-2xl ring-2 ring-black ring-opacity-10 overflow-hidden slide-up transform transition-all duration-300 ${
              toast.type === 'success' ? 'bg-gradient-to-r from-green-50 to-green-100 ring-green-300' :
              toast.type === 'error' ? 'bg-gradient-to-r from-red-50 to-red-100 ring-red-300' :
              toast.type === 'warning' ? 'bg-gradient-to-r from-yellow-50 to-yellow-100 ring-yellow-300' :
              'bg-gradient-to-r from-blue-50 to-blue-100 ring-blue-300'
            }`}
          >
            <div className="p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  {toast.type === 'success' ? (
                    <CheckCircleIcon className="h-10 w-10 text-green-500" />
                  ) : (
                    <ExclamationCircleIcon className={`h-10 w-10 ${
                      toast.type === 'error' ? 'text-red-500' :
                      toast.type === 'warning' ? 'text-yellow-500' :
                      'text-blue-500'
                    }`} />
                  )}
                </div>
                <div className="ml-4 w-0 flex-1">
                  <p className={`text-xl font-bold ${
                    toast.type === 'success' ? 'text-green-900' :
                    toast.type === 'error' ? 'text-red-900' :
                    toast.type === 'warning' ? 'text-yellow-900' :
                    'text-blue-900'
                  }`}>
                    {toast.title}
                  </p>
                  {toast.message && (
                    <p className={`mt-2 text-lg ${
                      toast.type === 'success' ? 'text-green-700' :
                      toast.type === 'error' ? 'text-red-700' :
                      toast.type === 'warning' ? 'text-yellow-700' :
                      'text-blue-700'
                    }`}>
                      {toast.message}
                    </p>
                  )}
                </div>
                <div className="ml-4 flex-shrink-0 flex">
                  <button
                    className={`rounded-md inline-flex ${
                      toast.type === 'success' ? 'text-green-400 hover:text-green-500' :
                      toast.type === 'error' ? 'text-red-400 hover:text-red-500' :
                      toast.type === 'warning' ? 'text-yellow-400 hover:text-yellow-500' :
                      'text-blue-400 hover:text-blue-500'
                    } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
                    onClick={() => removeToast(toast.id)}
                  >
                    <span className="sr-only">關閉</span>
                    <XMarkIcon className="h-5 w-5" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ToastContainer;